import script from "./FiltersDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersDialog.vue?vue&type=script&setup=true&lang=js"

import "./FiltersDialog.vue?vue&type=style&index=0&id=51e0a2d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e0a2d3"]])

export default __exports__